import React, { useState, useEffect } from "react";

const RebootPopup = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Utility functions
  const hasSubmittedEmail = () =>
    window.localStorage.getItem("reboot_email_submitted") === "true";

  const markEmailSubmitted = () =>
    window.localStorage.setItem("reboot_email_submitted", "true");

  // Delay popup by 4 seconds, only if not already submitted
  useEffect(() => {
    if (!hasSubmittedEmail()) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      alert("⚠️ Please enter your email.");
      return;
    }

    if (isSubmitting) return;
    setIsSubmitting(true);

    const payload = {
      name: "",
      age: "",
      gender: "",
      city: "",
      phone: "",
      date_suits: "",
      price_suitable: "",
      reason: "",
      question: email,
    };

    try {
      // 1️⃣ Submit to AWS Lambda
      await fetch(
        "https://zbpje4azgliercmqvfqkh34bqm0mlmwm.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const BASE_URL =
        process.env.REACT_APP_ENV === "PROD"
          ? process.env.REACT_APP_API_BASE_URL_PROD
          : process.env.REACT_APP_API_BASE_URL_DEV;

      console.log("🛠️ BASE_URL is:", BASE_URL);

      // 2️⃣ Submit to internal subscriber API
      await fetch(`${BASE_URL}/add-subscriber`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      alert("✅ Email submitted successfully!");
      setEmail("");
      markEmailSubmitted();        // 🔒 Save to localStorage
      setIsVisible(false);         // ⛔ Hide popup
    } catch (error) {
      console.error("Error submitting email:", error);
      alert("⚠️ An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg max-w-md w-full text-center shadow-4xl border-8 border-secondary">
        <h2 className="text-3xl font-bold mb-5 leading-tight text-secondary">
          Reboot Your Mind. <br />
          Reclaim Your Energy.
        </h2>

        <p className="text-green-700 text-base mb-8">
          Get instant access to the <strong>Deep Mental Reboot Starter Kit</strong> — 3 simple rituals to cut the fog, boost your focus, and ground your nervous system in under 10 minutes a day.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-2 border-primary rounded-md py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              type="submit"
              className="bg-primary text-white py-3 px-6 rounded-md hover:bg-primary/90 transition text-base font-semibold"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Send me the free kit"}
            </button>

            <button
              type="button"
              onClick={() => setIsVisible(false)}
              className="bg-gray-200 text-secondary py-3 px-6 rounded-md hover:bg-gray-300 transition text-base font-semibold"
            >
              I don't want Reboot kit.
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RebootPopup;
